import {
    SET_PROMOTION,
    RESET_PROMOTION
} from "../actions/promotions"

const initialState = {}

export default (state = initialState, {
    type,
    payload
}) => {
    switch (type) {
        case SET_PROMOTION:
            return {
                ...payload
            }
        case RESET_PROMOTION:
            return initialState
        default:
            return state
    }
}